import { render, staticRenderFns } from "./resourceBox.vue?vue&type=template&id=0be5c58e&"
import script from "./resourceBox.vue?vue&type=script&lang=js&"
export * from "./resourceBox.vue?vue&type=script&lang=js&"
import style0 from "./resourceBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports